import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Select from "react-select";
import { HiOutlineCog, HiPlus } from "react-icons/hi";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const AccountSetting = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { url, hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [selectHotelList, setSelectHotelList] = useState([]);
  const [isModalAdd, setIsModalAdd] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [formValid,setFormValid] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [newUser, setNewUser] = useState({
    hotel_id: [],
    role_id: "",
    name: "",
    email: "",
    phone: "",
    password: "",
    conpass: "",
  });

  const getAccountList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/account/list/`);
      if (response.status === 200) {
        const processedData = response.data.data.map((account) => ({
          ...account,
          hotel_names: Array.isArray(account.hotel_names)
            ? account.hotel_names
            : typeof account.hotel_names === "string"
            ? account.hotel_names.split(",")
            : [],
        }));
        
        setAccountList(processedData);
      } else {
        throw new Error("Query / network reloading");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const getHotelList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/select/hotels`);
      if (response.status === 200) {
        setSelectHotelList(response.data);
      } else {
        throw new Error("Query / network reloading");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const getRoleList = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/select/roles`);
      if (response.status === 200) {
        setSelectedRole(response.data);
      } else {
        throw new Error("Query / network reloading");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
  
    // Validate if passwords match
    if (newUser.password !== newUser.conpass) {
      alert("Passwords do not match!");
      return;
    }
  
    // Prepare the payload
    const payload = {
      hotel_id: newUser.hotel_id,
      role_id: newUser.role_id,
      name: newUser.name,
      email: newUser.email,
      phone: newUser.phone,
      password: newUser.password,
    };

    try {
      // Send a POST request using Axios
      const response = await axios.post("/api/add/user", payload);
  
      if (response.status === 200) {
        toast.success(response.data.message);
        
        setIsModalAdd(false); // Close the modal
        // Optionally reset the form data
        setNewUser({
          hotel_id: [],
          role_id: "",
          name: "",
          email: "",
          phone: "",
          password: "",
          conpass: "",
        });
      } else {
        toast.info(response.data.message);
      }
    } catch (error) {
      console.error("Error adding user:", error);
      toast.error( error.response?.data?.message || "An error occurred while adding the user.")
      
    }
  };

  const doOpenDetailuser = (account) => {
    setSelectedAccount(account); // Set the selected account to edit
    setEditModalOpen(true); // Open the modal
  };

  const handleEditUser = async (e) => {
    e.preventDefault();
  
    // Prepare the payload
    const payload = {
      UID: selectedAccount.id,
      hotel_id: selectedAccount.hotel_id,
      role_id: selectedAccount.role_id,
      is_active: selectedAccount.is_active, 
    };
    
    try {
      const response = await axios.post(`/api/update/user`, payload);
     
      if (response.status === 200) {
        toast.success(response.data.message);
        setEditModalOpen(false); // Close the modal
        getAccountList()
      } else {
        toast.info(response.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update user');
    }
  };
  
  useEffect(() => {
    const userData = getUser();
    if (userData) {
      setUserData(userData);
      getAccountList();
      getHotelList();
      getRoleList();
    } else {
      navigate("/");
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
     <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar 
          setMiniSidebar={setMiniSidebar} 
          isMiniSidebar={isMiniSidebar} 
        />
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-4 text-sm text-[#101827]">
            <span>Ashley Hotel Group</span> &gt; <span>Account Setting</span>
          </div>
          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827]">
            <h4 className="text-base font-bold mb-4">Account List </h4>
            {isLoading ? (
              <p>Loading...</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full text-xs table-auto border-collapse border border-gray-200">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border border-gray-200 px-4 py-2 text-left">User</th>
                      <th className="border border-gray-200 px-4 py-2 text-left">Property</th>
                      <th className="border border-gray-200 px-4 py-2 text-left">Name</th>
                      <th className="border border-gray-200 px-4 py-2 text-left">Email</th>
                      <th className="border border-gray-200 px-4 py-2 text-left">Role</th>
                      <th className="border border-gray-200 px-4 py-2 text-left">Active</th>
                      <th className="border border-gray-200 px-4 py-2 text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountList.map((account, index) => (
                      <tr key={index} className={`odd:bg-white even:bg-gray-50 ${account.is_active === 99 ? 'font-bold text-red-500' : ''}`}>
                        <td className="border border-gray-200 flex justify-center items-center px-2 py-2">
                          {/* Display Thumbnail Image */}
                          <img 
                            src={account.img_user || 'https://placehold.co/50x50'} // Default image if no thumbnail is provided
                            alt={account.name}
                            className="w-14 h-14 object-cover border border-gray-200 p-1 rounded-full"
                          />
                        </td>
                        <td className="border border-gray-200 px-4 py-2">
                          <ul className="list-disc list-inside">
                            {account.hotel_names.map((hotel, i) => (
                              <li key={i}>{hotel}</li>
                            ))}
                          </ul>
                        </td>
                        <td className="border border-gray-200 px-4 py-2">{account.name}</td>
                        <td className="border border-gray-200 px-4 py-2">{account.email}</td>
                        <td className="border border-gray-200 px-4 py-2">{account.role_name}</td>
                        <td className="border border-gray-200 px-4 py-2">{account.is_active == 1 ? "Active" : "Non Active"}</td>
                        <td className="border border-gray-200 px-4 py-2">
                          <HiOutlineCog onClick={()=>doOpenDetailuser(account)}/>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </section>
        </main>
      </div>

      <button onClick={() => setIsModalAdd(true)} className="fixed bottom-5 right-5 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700">
        <HiPlus size={24} />
      </button>
      
      {/* Add User */}
      {isModalAdd && (
        <div className="fixed inset-0 flex items-center justify-center text-xs bg-gray-900 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">Add New User</h2>
            <form onSubmit={ handleAddUser} >
              <div className="mb-2">
                <label htmlFor="hotel" className="block font-medium text-gray-700 mb-1">
                  Select Hotel
                </label>
                <Select
                  options={selectHotelList}
                  isMulti 
                  onChange={(options) => {
                    const selectedValues = options.map((option) => option.value); // Extract values from selected options
                    setNewUser({ ...newUser, hotel_id: selectedValues });
                  }}
                  placeholder="Select"
                  className="mb-2"
                />
              </div>

              <div className="mb-2">
                <label htmlFor="role" className="block font-medium text-gray-700 mb-2">
                  Select Role
                </label>
                <Select
                  options={selectedRole}
                  onChange={(option) => setNewUser({ ...newUser, role_id: option.value })}
                  placeholder="Role Account"
                  className="mb-6"
                />
              </div>

              <div className="mb-2">
                <label htmlFor="name" className="block font-medium text-gray-700 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  placeholder="Name"
                  value={newUser.name || ""}
                  onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                  required
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="mb-2">
                <label htmlFor="email" className="block font-medium text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="user@corporate.com"
                  value={newUser.email || ""}
                  onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                  required
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="mb-2">
                <label htmlFor="phone" className="block font-medium text-gray-700 mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="+62 xxxx xxxx"
                  value={newUser.phone || ""}
                  onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })}
                  required
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="mb-2">
                <label htmlFor="password" className="block font-medium text-gray-700 mb-2">
                  Password
                </label>
                <input
                    type="password"
                    id="password"
                    placeholder="Password"
                    value={newUser.password || ""}
                    onChange={(e) => {
                      const password = e.target.value;
                      setNewUser({ ...newUser, password });
                      setFormValid(password.length <= 8); // Disable button if password > 8 chars
                    }}
                    required
                    className={`w-full p-2 border rounded ${
                      newUser.password && newUser.password.length > 8 ? "border-red-500" : "border-gray-300"
                    }`}
                />
                {newUser.password && newUser.password.length > 8 && (
                  <p className="text-red-500 text-xs mt-1">Password cannot exceed 8 characters.</p>
                )}
              </div>

              <div className="mb-2">
                <label htmlFor="conpass" className="block font-medium text-gray-700 mb-2">
                  Confirm Password
                </label>
                <input
                  type="password"
                  id="conpass"
                  placeholder="Confirm Password"
                  value={newUser.conpass || ""}
                  onChange={(e) => setNewUser({ ...newUser, conpass: e.target.value })}
                  required
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setIsModalAdd(false)}
                  className="px-4 py-2 bg-gray-300 rounded mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={
                    !formValid || // Password validation
                    !newUser.name || // Ensure all required fields are filled
                    !newUser.email ||
                    !newUser.phone
                  }
                  className={`px-4 py-2 rounded ${
                    !formValid ||
                    !newUser.name ||
                    !newUser.email ||
                    !newUser.phone
                      ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                      : "bg-blue-600 text-white"
                  }`}
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

     
      {/* Edit User Modal */}
      {editModalOpen && selectedAccount && (
        <div className="fixed inset-0 flex items-center justify-center text-xs bg-gray-900 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4">{selectedAccount.name}</h2>
            <form onSubmit={handleEditUser}>
              {/* Hotel Selection */}
              <div className="mb-2">
                <label htmlFor="hotel" className="block font-medium text-gray-700 mb-1">
                  Select Hotel
                </label>
                <Select
                  options={selectHotelList} // List of available hotels
                  value={selectHotelList.filter((hotel) =>
                    selectedAccount.hotel_id.includes(hotel.value)
                  )}
                  onChange={(options) => {
                    const selectedHotelIds = options.map(option => option.value);
                    setSelectedAccount({ ...selectedAccount, hotel_id: selectedHotelIds });
                  }}
                  isMulti
                  placeholder="Select Hotels"
                  className="mb-2"
                />
              </div>

              {/* Role Selection */}
              <div className="mb-2">
                <label htmlFor="role" className="block font-medium text-gray-700 mb-1">
                  Select Role
                </label>
                <Select
                  options={selectedRole}
                  value={selectedRole.find(role => role.value === selectedAccount.role_id)}
                  onChange={(option) => setSelectedAccount({ ...selectedAccount, role_id: option.value })}
                  placeholder="Select Role"
                  className="mb-6"
                />
              </div>

              {/* Status (Active/Inactive) */}
              <div className="mb-2 flex items-center">
                <label htmlFor="status" className="block font-medium text-gray-700 mr-2">
                  Active
                </label>
                <input
                  type="checkbox"
                  id="status"
                  checked={selectedAccount.is_active === 1}
                  onChange={(e) => 
                    setSelectedAccount({
                      ...selectedAccount,
                      is_active: e.target.checked ? 1 : 99  // Set to 1 if checked, 99 if unchecked
                    })
                  }
                  className="w-4 h-4"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setEditModalOpen(false)}
                  className="px-4 py-2 bg-gray-300 rounded mr-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default AccountSetting;